import {getPageTitle} from '~/utils/seoUtils'

export const getPageMetadata = (pageId) => {
  if (!pageId) {
    console.warn('getPageMetadata: pageId is required')
    return
  }

  return staticPageMetadata?.[pageId] || null
}

const staticPageMetadata = {
  'search': {
    title: 'Búsqueda',
    meta: [
      { name: 'robots', content: 'noindex,nofollow' }
    ]
  },
  'create-account': {
    title: 'Crear Cuenta',
    meta: [
      { name: 'description', content: `Crea una cuenta para realizar compras mas rápido.` },
      { name: 'robots', content: 'index,follow' }
    ]
  },
  'login': {
    title: 'Iniciar sesión',
    meta: [
      { name: 'description', content: 'Pelucas y prótesis capilares para hombre y mujer - Productos de limpieza, mantenimiento y colocación de pelucas-espana y prótesis capilares.' },
      { name: 'robots', content: 'index,follow' }
    ]
  },
  'logout': {
    title: 'Cerrando sesión...',
    meta: [
      { name: 'robots', content: 'noindex,nofollow' }
    ]
  },
  'request-password': {
    title: 'Solicitar nueva contraseña',
    meta: [
      { name: 'description', content: 'Pelucas y prótesis capilares para hombre y mujer - Productos de limpieza, mantenimiento y colocación de pelucas-espana y prótesis capilares.' },
      { name: 'robots', content: 'index,follow' }
    ]
  },
  'activate-account': {
    title: 'Activa tu cuenta',
    meta: [
      { name: 'robots', content: 'noindex,nofollow' }
    ]
  },
  'order-completed': {
    title: 'Pedido realizado',
    meta: [
      { name: 'robots', content: 'noindex,nofollow' }
    ]
  },
  'buy-confirm-order': {
    title: 'Confirma tu pedido',
    meta: [
      { name: 'robots', content: 'noindex,nofollow' }
    ]
  },
  'buy-send-billing-data': {
    title: 'Envío y Facturación',
    meta: [
      { name: 'robots', content: 'noindex,nofollow' }
    ]
  },
  'buy-cart': {
    title: 'Datos de Productos de la Compra',
    meta: [
      { name: 'robots', content: 'noindex,nofollow' }
    ]
  },
  'buy-login-or-anon': {
    title: 'Inicia sesión para comprar o continúa como anónimo',
    meta: [
      { name: 'robots', content: 'noindex,nofollow' }
    ]
  },
  'pricing-table-login': {
    title: 'Acceso Tarifario',
    meta: [
      { name: 'description', content: 'Pelucas y prótesis capilares para hombre y mujer - Productos de limpieza, mantenimiento y colocación de pelucas-espana y prótesis capilares.' },
      { name: 'robots', content: 'index,follow' }
    ]
  },
  'pricing-table': {
    title: 'Tarifario',
    meta: [
      { name: 'robots', content: 'noindex,nofollow' }
    ]
  },
  'profile': {
    title: 'Perfil',
    meta: [
      { name: 'robots', content: 'noindex,nofollow' }
    ]
  },
  'profile-invoices': {
    title: 'Mis Pedidos',
    meta: [
      { name: 'robots', content: 'noindex,nofollow' }
    ]
  },
  'profile-courses': {
    title: 'Mis Cursos',
    meta: [
      { name: 'robots', content: 'noindex,nofollow' }
    ]
  },
  'survey-item': {
    title: 'Encuesta',
    meta: [
      { name: 'robots', content: 'noindex,nofollow' }
    ]
  }
}
